import * as React from "react";
import { v4 } from "uuid";

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Badge from '@material-ui/core/Badge';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';

import "./../../resources/forest.jpg";

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Chip from '@material-ui/core/Chip';
import AlarmIcon from '@material-ui/icons/Alarm';
import AssignmentTurnedIn from '@material-ui/icons/AssignmentTurnedIn';


import { ThemeProvider } from '@material-ui/core/styles';

import { createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import { ExerciseTask, TaskOption, Exercise, Examination } from '../server/ExamServer'
import ExamTask from "./ExamTask";
import ExamExercise from "./ExamExercise";
import CircularProgress from '@material-ui/core/CircularProgress';

import ExamServer from '../server/ExamServer'


const theme = createMuiTheme({
    palette: {
        // primary: {
        //     main: '#44423e'
        // },
        // secondary: {
        //     main: '#FDC400',
        //     contrastText: '#fff'
        // }
    }

});



export interface ExamProps {

    onFinished:() => void
    onTimeExceeded:() => void
}

export interface ExamState {
    exam: Examination | undefined
    timeLeft: number
}


class Exam extends React.Component<ExamProps, ExamState> {

    timeout:NodeJS.Timer|number|null = null;
    server: ExamServer;
    constructor(props: ExamProps) {
        super(props);
        this.state = {
            exam: undefined,
            timeLeft:0
        };

        this.server = new ExamServer()
        this.server.getExam().then(exec => {
            this.setState({ 
                exam:exec.examination,
                timeLeft:exec.time//exam.time
            })

            this.timeout = setInterval(()=>{
                this.setState({ 
                    timeLeft:(this.state.timeLeft>1000)?(this.state.timeLeft-1000):(0)
                })

                if(this.state.timeLeft === 0){
                    this.props.onTimeExceeded && this.props.onTimeExceeded()
                    clearInterval(this.timeout as number)
                }
            },1000)
        })


    }


    finish = () =>{
        this.props.onFinished && this.props.onFinished()
    }

    getProgressInfo = ():string =>{


        let tasks:number = 0;
        let done:number = 0;

        this.state.exam && this.state.exam.exercises.forEach(currentExercise => {

                currentExercise.tasks.forEach(currentTask => {

                        tasks++
                        let oneIsChecked:boolean = false;
                        currentTask.options.forEach(currentOption => {

                                if(currentOption.checked){
                                    oneIsChecked=true;
                                }
                        })
                        if(oneIsChecked){
                            done++
                        }

                })
        })

        return done + "/" + tasks
    }


    handleSelect = (option: TaskOption, task: ExerciseTask, exercise: Exercise) => {
        //this.props.onSelect && this.props.onSelect(option, task, exercise);
        console.log(option, task, exercise)



        let newState = Object.assign({}, this.state);

        newState.exam && newState.exam.exercises.forEach(currentExercise => {

            if (currentExercise.id === exercise.id) {
                currentExercise.tasks.forEach(currentTask => {

                    if (currentTask.id === task.id) {
                        currentTask.options.forEach(currentOption => {
                            if (currentOption.id === option.id) {
                                if(currentOption.checked){
                                    currentOption.checked = !currentOption.checked
                                }
                                else{
                                    currentOption.checked = true
                                }
                                this.server.choice(exercise.key, task.key, option.key, currentOption.checked)
                                
                            }
                            else{
                                currentOption.checked = false;
                            }

                        })
                    }

                })
            }

        })


        // if (!newState.exam[systemVariant.id]) {
        //     newState.selection[systemVariant.id] = {
        //         wcId: selectedId,
        //         color: "ecd32933-f864-4a36-b604-ee4e9b4b3aa2",
        //         type: systemVariant.type
        //     }
        // }

        // newState.selection[systemVariant.id].wcId = selectedId
        this.setState(newState)





    }


    render() {

        return (
            <React.Fragment>



                {this.state.exam ? (



                    <React.Fragment>

                        <AppBar position="fixed">
                            <Toolbar>

                                <Typography variant="h6" style={{ flexGrow: 1 }}>
                                    {this.state.exam.name}
                                </Typography>
                                {/* <IconButton edge="start" color="inherit" aria-label="menu"style={{marginRight: theme.spacing(2)}}>
                                    <MenuIcon />
                                </IconButton>
                                <Button color="inherit">Help</Button> */}

                                {/* <Chip
                                    style={{marginRight:theme.spacing(1)}}
                                    icon={<AssignmentTurnedIn />}
                                    color={"primary"}
                                    label={this.getProgressInfo()}
                                    clickable={false}
                                /> */}


                                <Chip
                                    icon={<AlarmIcon />}
                                    color={"primary"}
                                    label={new Date(this.state.timeLeft).toISOString().slice(11, -5)}
                                    clickable={false}
                                />
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={this.finish}
                                >Finish
                                </Button>

                            </Toolbar>
                        </AppBar>
                                
                        <div style={{ height: "60px" }}></div>
                        {this.state.timeLeft>0?(
                             <React.Fragment>
                                {this.state.exam && this.state.exam.exercises.map(exercise => {
                                    return <ExamExercise exercise={exercise} onSelect={this.handleSelect} />
                                })}
                            </React.Fragment>
                        ):null}

                        <div style={{margin:theme.spacing(3), marginTop:theme.spacing(5), marginBottom:theme.spacing(8)}}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={this.finish}
                            >Finish</Button>
                        </div>



                    </React.Fragment>
                ) : (
                    <Grid container
                        justify="center"
                        alignItems="center"
                        style={{
                            height: "calc(100vh - 100px)"
                        }}
                    >
                        <Grid item md={8} lg={6} xl={6} style={{textAlign:"center"}}>
                            <CircularProgress color="secondary" />
                        </Grid>
                    </Grid>
                    )}

            </React.Fragment>

        );
    }
}

export default Exam;
